import http from '@axios'
import paramsConverter from './utils/paramsConverter'

const resource = '/api/v1/answer'
const resourceAdd = '/api/v1/question'

export default {
  list(params = {}) {
    const paramsString = paramsConverter(params)

    return http.get(`${resource}${paramsString}`)
  },
  add(answer, uuid) {
    return http.post(`${resourceAdd}/${uuid}/add-answer`, answer)
  },
  get(uuid) {
    return http.get(`${resource}/${uuid}`)
  },
  update(answer, uuid) {
    return http.put(`${resource}/${uuid}`, answer)
  },
  destroy(uuid) {
    return http.delete(`${resource}/${uuid}`)
  },
}
